export function ComplianceNote({ className = "" }) {
  return (
    <p className={`text-xs text-gray-500 leading-relaxed ${className}`}>
      <strong className="text-gray-400">Disclaimer di conformità:</strong> Le attività svolte da
      OPERA Real Estate Partners consistono esclusivamente in advisory strategica, analisi
      economico-finanziaria, due diligence e gestione di progetti di riqualificazione patrimoniale.
      Ai sensi e per gli effetti della Legge n. 39/1989 e successive modifiche, le attività di
      mediazione immobiliare e la stipula di atti vincolanti sono demandate in via esclusiva ad
      agenzie abilitate e pubblici ufficiali delegati.
    </p>
  );
}
